import { render, staticRenderFns } from "./ModFunctionButton.vue?vue&type=template&id=8d1a6bf2"
import script from "./ModFunctionButton.vue?vue&type=script&lang=js"
export * from "./ModFunctionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports